import { RouteLink } from '../route';
import PortalLayout from './PortalLayout';

export default function NotFoundPage() {
  return (
    <PortalLayout>
      <section className="not-found-card">
        <p className="hero-kicker">Route Not Found</p>
        <h1>This documentation route is not available.</h1>
        <p>
          The page may have been renamed while the portal was being reorganized.
          Return to the overview to continue browsing the module library.
        </p>
        <RouteLink className="action-primary" to="/">
          Return to Portal
        </RouteLink>
      </section>
    </PortalLayout>
  );
}
